import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import "./BlogDetails.css";
import { FaFacebookF, FaXTwitter, FaPinterest, FaPlus } from "react-icons/fa6";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";

const BlogDetails = () => {
  const [blogData, setBlogData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    fetchBlogDetails();
  }, [id]);

  const fetchBlogDetails = async () => {
    try {
      const response = await axios.get(`https://api.swasthmitra.com/api/blogs/${id}`);
      setBlogData(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching blog details:", error);
      setLoading(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (loading) {
    return <div className="loading">Loading blog details...</div>;
  }

  if (!blogData) {
    return <div className="error">Blog not found</div>;
  }

  const { blog, navigation, relatedBlogs } = blogData;

  return (
    <motion.div
      className="blogDetails"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="blogHeader">
        <motion.img
          src={blog.imageUrl}
          alt={blog.title}
          initial={{ scale: 1.1 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5 }}
        />
        <div className="blogInfo">
          <h1>{blog.title}</h1>
          <div className="blogMeta">
            <p>By {blog.author}</p>
            <p>{new Date(blog.createdAt).toLocaleDateString()}</p>
            <p>{blog.readTime} min read</p>
            <p>Category: {blog.category}</p>
          </div>
          <div className="blogTags">
            {blog.tags.map((tag, index) => (
              <span key={index} className="tag">
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="blogContent">
        {blog.content.split("\n").map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>

      <div className="share-buttons">
        <button className="share-button facebook">
          <FaFacebookF /> Share on Facebook
        </button>
        <button className="share-button twitter">
          <FaXTwitter /> Share on Twitter
        </button>
        <button className="share-button pinterest">
          <FaPinterest /> Share on Pinterest
        </button>
        <button className="share-button more">
          <FaPlus size={20} />
        </button>
      </div>

      <div className="blogDetailsNextPrev">
        {navigation.previous && (
          <div className="blogDetailsNextPrevContainer">
            <Link
              to={`/blog/${navigation.previous._id}`}
              className="blogDetailsNextPrevContainerIcon"
              onClick={scrollToTop}
            >
              <GoChevronLeft size={20} />
              <p>PREVIOUS POST</p>
            </Link>
            <p>{navigation.previous.title}</p>
          </div>
        )}
        {navigation.next && (
          <div className="blogDetailsNextPrevContainer">
            <Link
              to={`/blog/${navigation.next._id}`}
              className="blogDetailsNextPrevContainerIcon2"
              onClick={scrollToTop}
            >
              <p>NEXT POST</p>
              <GoChevronRight size={20} />
            </Link>
            <p style={{ textAlign: "right" }}>{navigation.next.title}</p>
          </div>
        )}
      </div>

      {relatedBlogs.length > 0 && (
        <div className="relatedBlogs">
          <h2>Related Posts</h2>
          <div className="relatedBlogsGrid">
            {relatedBlogs.map((relatedBlog) => (
              <Link
                to={`/blog/${relatedBlog._id}`}
                key={relatedBlog._id}
                className="relatedBlogCard"
                onClick={scrollToTop}
              >
                <img src={relatedBlog.imageUrl} alt={relatedBlog.title} />
                <div className="relatedBlogInfo">
                  <h3>{relatedBlog.title}</h3>
                  <p>By {relatedBlog.author}</p>
                  <p>{new Date(relatedBlog.createdAt).toLocaleDateString()}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default BlogDetails;
